import { BehaviorSubject, Subject } from 'rxjs';

/**
 * Interface representing a general event in the application.
 * Used for type-safe event handling across components.
 */
export interface IgeneralEvent {

  /** The type/name of the event */
  type: string;

  /** Optional data payload associated with the event */
  data?;
}

/**
 * Central event bus for application-wide communication using RxJS BehaviorSubjects.
 * Provides a simple pub/sub mechanism for different types of events.
 */
export class Eventbus {
  /** Subject for photo-related events, emits photo URLs as strings */
  onphoto$ = new Subject<string>();

  /** Subject for emoji feedback events, type is currently untyped (null) */
  emojifeedback$ = new Subject();

  /** Subject for general application events, uses IgeneralEvent interface */
  generalEvent$: BehaviorSubject<IgeneralEvent | null> =
    new BehaviorSubject<IgeneralEvent | null>(null);

  /**
   * Creates an instance of Eventbus.
   * Initializes all BehaviorSubject instances.
   */
  constructor() { }
}